export default {
  // createRelease
  START_CREATE_RELEASE: 'START_CREATE_RELEASE',
  CREATE_RELEASE_SUCCESS: 'CREATE_RELEASE_SUCCESS',
  CREATE_RELEASE_FAILED: 'CREATE_RELEASE_FAILED',
  // getReleaseList
  START_GET_RELEASE_LIST: 'START_GET_RELEASE_LIST',
  GET_RELEASE_LIST_SUCCESS: 'GET_RELEASE_LIST_SUCCESS',
  GET_RELEASE_LIST_FAILED: 'GET_RELEASE_LIST_FAILED',
  // getReleaseById
  START_GET_RELEASE_BY_ID: 'START_GET_RELEASE_BY_ID',
  GET_RELEASE_BY_ID_SUCCESS: 'GET_RELEASE_BY_ID_SUCCESS',
  GET_RELEASE_BY_ID_FAILED: 'GET_RELEASE_BY_ID_FAILED',
  // getReleasesForApplication
  START_GET_RELEASE_BY_APP_ID: 'START_GET_RELEASE_BY_APP_ID',
  GET_RELEASE_BY_APP_ID_SUCCESS: 'GET_RELEASE_BY_APP_ID_SUCCESS',
  GET_RELEASE_BY_APP_ID_FAILED: 'GET_RELEASE_BY_APP_ID_FAILED',
  // updateRelease
  START_UPDATE_RELEASE: 'START_UPDATE_RELEASE',
  UPDATE_RELEASE_SUCCESS: 'UPDATE_RELEASE_SUCCESS',
  UPDATE_RELEASE_FAILED: 'UPDATE_RELEASE_FAILED',
  // sendForApproval
  START_SEND_FOR_APPROVAL: 'START_SEND_FOR_APPROVAL',
  SEND_FOR_APPROVAL_SUCCESS: 'SEND_FOR_APPROVAL_SUCCESS',
  SEND_FOR_APPROVAL_FAILED: 'SEND_FOR_APPROVAL_FAILED',
  // cancelApproval
  START_CANCEL_APPROVAL: 'START_CANCEL_APPROVAL',
  CANCEL_APPROVAL_SUCCESS: 'CANCEL_APPROVAL_SUCCESS',
  CANCEL_APPROVAL_FAILED: 'CANCEL_APPROVAL_FAILED',
   // cloneRelease
  START_CLONE_RELEASE: 'START_CLONE_RELEASE',
  CLONE_RELEASE_SUCCESS: 'CLONE_RELEASE_SUCCESS',
  CLONE_RELEASE_FAILED: 'CLONE_RELEASE_FAILED',
}
